import { PerformanceTabItem } from './retailer-network-performance-page.types';

export const LOYALTY_PROGRAM_TAB: PerformanceTabItem = {
  label: 'Loyalty Program',
  value: 'loyalty-program',
};

export const TOBACCO_PROGRAM_TAB: PerformanceTabItem = {
  label: 'Tobacco Program',
  value: 'tobacco-program',
};

export const LOYALTY_PROGRAM_TAB_PATH = 'loyalty-program';
export const TOBACCO_PROGRAM_TAB_PATH = 'tobacco-program';
